
import React from 'react';
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Product } from "@/types";
import { CannabinoidProps } from "@/types/componentProps";

const CannabinoidPercentages: React.FC<CannabinoidProps> = ({
  product,
  onChange
}) => {
  const handleInputChange = (field: string, value: string) => {
    const numValue = value === '' ? 0 : parseFloat(value);
    onChange({ [field]: numValue });
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      <div className="space-y-2">
        <Label htmlFor="indica-percentage">Indica %</Label>
        <Input
          id="indica-percentage"
          type="number"
          inputMode="decimal"
          value={product.indica_percentage || ''}
          onChange={(e) => handleInputChange('indica_percentage', e.target.value)}
          placeholder="0.00"
        />
        <div className="text-sm text-muted-foreground">
          Sativa: {100 - (product.indica_percentage || 0)}%
        </div>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="thc-percentage">THC %</Label>
        <Input
          id="thc-percentage"
          type="number"
          inputMode="decimal"
          value={product.thc_percentage || ''}
          onChange={(e) => handleInputChange('thc_percentage', e.target.value)}
          placeholder="0.00"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="cbd-percentage">CBD %</Label>
        <Input
          id="cbd-percentage"
          type="number"
          inputMode="decimal"
          value={product.cbd_percentage || ''}
          onChange={(e) => handleInputChange('cbd_percentage', e.target.value)}
          placeholder="0.00"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="cbg-percentage">CBG %</Label>
        <Input
          id="cbg-percentage"
          type="number"
          inputMode="decimal"
          value={product.cbg_percentage || ''}
          onChange={(e) => handleInputChange('cbg_percentage', e.target.value)}
          placeholder="0.00"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="cbn-percentage">CBN %</Label>
        <Input
          id="cbn-percentage"
          type="number"
          inputMode="decimal"
          value={product.cbn_percentage || ''}
          onChange={(e) => handleInputChange('cbn_percentage', e.target.value)}
          placeholder="0.00"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="cbc-percentage">CBC %</Label>
        <Input
          id="cbc-percentage"
          type="number"
          inputMode="decimal"
          value={product.cbc_percentage || ''}
          onChange={(e) => handleInputChange('cbc_percentage', e.target.value)}
          placeholder="0.00"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="thcv-percentage">THCV %</Label>
        <Input
          id="thcv-percentage"
          type="number"
          inputMode="decimal"
          value={product.thcv_percentage || ''}
          onChange={(e) => handleInputChange('thcv_percentage', e.target.value)}
          placeholder="0.00"
        />
      </div>
    </div>
  );
};

export default CannabinoidPercentages;
